import { useEffect, useState } from "react";
import { topicItems } from "@/mocks/gossip";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="bg-background-200 text-foreground-900">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6 py-12 md:py-16 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <a href="#top" className="flex items-center gap-2">
            <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-primary-500 text-background-50">
              <i className="ri-eye-2-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg text-foreground-950">海外吃瓜</span>
              <span className="font-latin tracking-[0.2em] text-[10px] text-primary-600">SCOOP HUB</span>
            </span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-sm">
            聚合海外网红黑料与博主翻车现场的中文资讯站，逐帧还原过程、归档人物档案，陪你理性吃瓜，一次吃透完整经过。
          </p>
          <div className="mt-5 flex items-center gap-2.5">
            {["ri-twitter-x-line", "ri-youtube-line", "ri-instagram-line", "ri-tiktok-line"].map((ic) => (
              <a
                key={ic}
                href="#top"
                aria-label="社交媒体链接"
                className="flex items-center justify-center w-10 h-10 rounded-xl bg-background-50 border border-background-300 text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors"
              >
                <i className={`${ic} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>

        <nav>
          <h3 className="font-heading font-bold text-base text-foreground-950">热门话题</h3>
          <ul className="mt-4 grid grid-cols-2 gap-2.5">
            {topicItems.slice(0, 8).map((t) => (
              <li key={t.id}>
                <a href="#topics" className="text-sm text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap">
                  {t.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-heading font-bold text-base text-foreground-950">快速入口</h3>
          <ul className="mt-4 space-y-2.5">
            {[
              { label: "今日热瓜", href: "#hot" },
              { label: "逐帧还原现场", href: "#scene" },
              { label: "前后对比证据", href: "#evidence" },
              { label: "人物档案", href: "#archive" },
              { label: "常见问题", href: "#faq" },
              { label: "投稿爆料", href: "#contact" },
            ].map((l) => (
              <li key={l.label}>
                <a href={l.href} className="inline-flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <i className="ri-arrow-right-s-line text-primary-500"></i>{l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-300">
        <div className="mx-auto max-w-[1320px] px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 海外吃瓜 Scoop Hub · 本站内容基于公开信息整理，不代表平台立场
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#about" className="hover:text-primary-700 whitespace-nowrap">关于我们</a>
            <a href="#faq" className="hover:text-primary-700 whitespace-nowrap">内容原则</a>
            <a href="#contact" className="hover:text-primary-700 whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>

      {showTop && (
        <a
          href="#top"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-12 h-12 rounded-full bg-foreground-950 text-background-50 hover:bg-primary-600 shadow-none transition-colors"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </a>
      )}
    </footer>
  );
}